var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vueVimeoPlayer',{ref:"player",attrs:{"video-id":_vm.vimeo_video_id,"autoplay":_vm.autoPlayBool,"controls":_vm.controls,"loop":_vm.loop,"options":{ responsive: true, muted:'muted' }},on:{"ready":_vm.onReady}})
}
var staticRenderFns = []

export { render, staticRenderFns }